<template>
    <div class="container" v-if="coupon">
        <v-title :lineage="[{'Coupons':'coupons'}]">
            <span v-fs-block>{{coupon.redemptionCode}}</span>
            <div slot="actions">
                <router-link
                    v-if="$auth.$pages['update-coupon'].isAllowed"
                    class="btn btn-primary" :to="{name: 'update-coupon', params: {id: id}}">
                    Edit Coupon
                </router-link>
            </div>
        </v-title>
        <div class="grid">
            <div class="grid-item grid-item-primary">
                <div class="grid">
                    <div class="grid-item grid-item-full">
                        <coupon-summary :coupon="coupon"/>
                    </div>
                    <div class="grid-item grid-item-full">
                        <redemption-grid :redemption-code="id" title="Coupons Redemptions">
                            <h2 slot="title">Coupon Redemptions</h2>
                            <p slot="no-content" class="text-muted padding-left-default">There are no redemptions associated with this coupon.</p>
                        </redemption-grid>
                    </div>
                </div>
            </div>
            <div class="grid-item grid-item-secondary">
                <coupon-restrictions-summary :coupon="coupon"/>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import CouponModel from '@/common/models/coupon-model';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import CouponSummary from './components/coupon-summary';
    import CouponRestrictionsSummary from './components/coupon-restrictions-summary';
    import RedemptionGrid from './components/redemption-grid';

    export default {
        name: 'coupon-details',
        mixins: [LoadStateMixin],
        components: {
            vTitle,
            CouponSummary,
            CouponRestrictionsSummary,
            RedemptionGrid,
        },
        props: {
            id: String,
        },
        data() {
            return {
                coupon: null,
            };
        },
        methods: {
            async fetchData() {
                const params = {redemptionCode: this.id};
                const {fields} = await this.$api(({coupons}) => coupons.get(params));
                this.coupon = new CouponModel(fields);
            },
        },
    };
</script>
